export const RIGHT_WORKSPACE_SIDEBAR_DEFAULT_WIDTH_PX = 560;
export const RIGHT_WORKSPACE_SIDEBAR_MIN_WIDTH_PX = 360;
export const RIGHT_WORKSPACE_SIDEBAR_MAX_WIDTH_PX = 720;
export const RIGHT_WORKSPACE_SIDEBAR_RESIZE_STEP_PX = 16;

export function clampRightWorkspaceSidebarWidth(width: number): number {
  if (!Number.isFinite(width)) {
    return RIGHT_WORKSPACE_SIDEBAR_DEFAULT_WIDTH_PX;
  }

  return Math.min(
    RIGHT_WORKSPACE_SIDEBAR_MAX_WIDTH_PX,
    Math.max(RIGHT_WORKSPACE_SIDEBAR_MIN_WIDTH_PX, Math.round(width)),
  );
}
